/** @format */

import React, { useState } from "react";
import { useCreateFetch } from "../../data/Queries";
import { walkinRatingCreate } from "../../data/ApiEndpoints";
import { toast } from "react-toastify";

const RatingFeedback = ({ token, userForm, userDetails, onClose }) => {
  const [formData, setFormData] = useState({});
  const { mutateAsync: createFollowup } = useCreateFetch({
    url: walkinRatingCreate,
    token,
    key: walkinRatingCreate,
  });

  const isValidReviewData = () => {
    const { rating, comment } = formData;

    if (!rating || !comment) {
      toast.error("All fields are required");
      return false;
    }

    if (isNaN(rating)) {
      toast.error("Invalid numeric rating");
      return false;
    }

    if (`${comment}`.trim().length > 1500) {
      toast.error("Comment is too long!");
      return false;
    }

    if (`${comment}`.trim().length < 3) {
      toast.error("Comment is too short!");
      return false;
    }

    return true;
  };

  async function handleClick() {
    try {
      if (!isValidReviewData()) return;
      const body = {
        rating: formData?.rating,
        gym_id: userForm?.gym_id,
        user_id: userDetails?.uid,
        comment: `${formData?.comment}`.trim(),
      };

      const { status, message } = await createFollowup(body);
      if (status) {
        onClose();
        toast.success(message);
      } else {
        toast.error(message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="timer-wrapper">
      <div className="flex-k js-center-k items-center-k gap-2-k my-4 flex-col-k">
        <h3>Rate your gym experience</h3>

        <div className="rating-wrapper">
          {Array.from({ length: 10 })
            .fill(0)
            .map((_, i) => (
              <span
                key={i}
                onClick={() => setFormData({ ...formData, rating: i + 1 })}
                className={`${
                  i + 1 === formData?.rating ? "active" : ""
                } ratings`}
              >
                {i + 1}
              </span>
            ))}
        </div>

        <div className="w-full-k">
          <textarea
            name="remark"
            value={formData?.comment}
            placeholder="Share your feedback so that we can improve.."
            rows="8"
            onChange={(e) =>
              setFormData({ ...formData, comment: e?.target?.value })
            }
            className="input-k feedback-desc text-area-k"
          ></textarea>
        </div>

        <div className="flex-k js-end-k w-full-k">
          <button className="btn-k btn-primary-k large" onClick={handleClick}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default RatingFeedback;
